<template>
  <div class="material" :class="{'materialDark':isDark}">
    <div class="information">
      <div class="title">
        <p></p>
        <p>基本信息</p>
      </div>
      <div class="info" v-if="playerInfo">
        <div class="top">
          <p><span>家乡:</span>{{playerInfo.come_from || '-'}}</p>
          <p><span>国籍:</span> {{playerInfo.country || '-'}}</p>
          <p><span>年薪:</span> ${{playerInfo.salary || '-'}}W</p>
        </div>
        <div class="bottom">
          <p><span>选秀情况:</span> {{playerInfo.draft || '-'}}</p>
          <p><span>生涯:</span> {{playerInfo.nba_age || '-'}}年</p>
        </div>
      </div>
    </div>
    <div class="transfer" v-if="transfer && transfer.length > 0">
      <div class="title">
        <p></p>
        <p>转会记录</p>
      </div>
      <div class="recordBox">
        <div class="record" v-for="(item,index) in transfer" :key="index">
          <div>{{item.transfer_time.replace(/-/g, '.')}}</div>
          <div class="club">
            <div class="left" @click="goTeam(item.team_id)">
              <p>{{item.team_name}}</p>
              <p><img :src="item.team_name_logo" alt=""></p>
            </div>
            <div class="mid">
              <p></p>
              <p></p>
              </div>
            <div class="right" @click="goTeam(item.now_team_id)">
              <p><img :src="item.now_team_name_logo" alt=""></p>
              <p>{{item.now_team_name}}</p>
            </div>
          </div>
          <div>{{item.type}}</div>
        </div>
      </div>
    </div>
    <div class="career" v-if="career && career.length > 0">
      <div class="title">
        <p></p>
        <p>职业生涯</p>
      </div>
      <div class="table">
        <p class="big">效力球队</p>
        <p class="big" style="width: 100px">效力时间</p>
        <p>出场</p>
        <p>得分</p>
        <p>助攻</p>
        <p>篮板</p>
        <p>抢断</p>
        <p>盖帽</p>
      </div>
      <div class="score" :style="index == 0 ? 'margin-top:15px' : ''" v-for="(item,index) in career" :key="index">
        <p class="big" @click="goTeam(item.team_id)">
          <span><img :src="item.logo" alt=""></span>
          <span style="text-align: left">{{item.team_name}}</span>
        </p>
        <p class="big" style="width: 100px">{{item.start_time.substring(0, 7).replace(/-/g, '.')}}-{{item.end_time.substring(0, 7).replace(/-/g, '.')}}</p>
        <p>{{item.sch}}</p>
        <p>{{item.score == 0 ? 0 : item.score ? item.score : '-'}}</p>
        <p>{{item.helpattack == 0 ? 0 : item.helpattack ? item.helpattack : '-'}}</p>
        <p>{{item.backboard == 0 ? 0 : item.backboard ? item.backboard : '-'}}</p>
        <p>{{item.rob == 0 ? 0 : item.rob ? item.rob : '-'}}</p>
        <p>{{item.cover == 0 ? 0 : item.cover ? item.cover : '-'}}</p>
      </div>
    </div>
    <div class="personalHonor" v-if="honor && honor.length > 0">
      <div class="title">
        <p></p>
        <p>个人荣誉</p>
      </div>
      <!-- <div class="cup">
        <div v-for="(item,index) in 3" :key="index">
          <p>
            <img src="" alt="">
          </p>
          <p>
            <span>4</span>
            <span>总冠军</span>
          </p>
        </div>
      </div> -->
      <div class="honor">
        <div v-for="(item,index) in honor" :key="index">
          <p>{{item.season.length}}</p>
          <p>{{item.honor}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPlayerBaseInfo } from "@/api/team.js"
import jsbridg from "@/utils/jsbridg.js"
export default {
    name: 'material',
    data () {
        return {
            player_id: this.$route.query.player_id || 78,
            honor: null,
            career: null,
            transfer: null
        }
    },
    computed: {
        playerInfo () {
            return this.$store.state.team.playerInfo
        },
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    created () {
        this.getInfo()
    },
    methods: {
        goTeam (id) {
            jsbridg.goWebview({
                url: process.env.VUE_APP_DOMAIN + `/team/database?team_id=${id}&top_bar_style=2`,
                jumptype: 2
            });
        },
        async getInfo () {
            const params = {
                player_id: this.player_id
            }
            const res = await getPlayerBaseInfo(params)
            if (res.errno === 0) {
                if (res.data) {
                    this.honor = res.data.honor
                    this.career = res.data.career
                    this.transfer = res.data.transfer
                }
            } else {
                this.$toast(res.errmsg)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.material {
  padding: 15px 0;
  background: #FFFFFF;
  .title {
    display: flex;
    align-items: center;
    p {
      &:first-child {
        width: 3px;
        height: 14px;
        background: #169AFF;
      }
      &:last-child {
        font-size: 13px;
        font-weight: bold;
        color: #333333;
        margin-left: 5px;
      }
    }
  }
  .information {
    padding: 0 12px;
    .info {
      margin-top: 10px;
      background: #FFFFFF;
      box-shadow: 0px 3px 5px 0px rgba(0,0,0,0.15);
      border-radius: 4px;
      border: 1px solid #EEEEEE;
      padding: 12px;
      .top, .bottom {
        display: flex;
        justify-content: space-between;
        p {
          font-size: 12px;
          font-weight: 400;
          color: #333333;
          span {
            color: #666666;
          }
        }
      }
      // .top {
      //   p {
      //     flex: 1;
      //     text-align: center;
      //     &:first-child {
      //       flex: none;
      //       width: 140px;
      //       text-align: left;
      //     }
      //     &:last-child {
      //       flex: none;
      //       text-align: right;
      //       width: 88px;
      //     }
      //   }
      // }
      .bottom {
        margin-top: 8px;
        // p {
        //   &:first-child {
        //     width: 250px;
        //   }
        //   &:last-child {
        //     flex: 1;
        //   }
        // }
      }
    }
  }
  .transfer {
    margin-top: 15px;
    padding: 0 12px;
    .recordBox {
      // margin-top: 5px;
      .record {
        margin-top: 10px;
        display: flex;
        align-items: center;
        div {
          &:first-child {
            width: 80px;
            font-size: 12px;
            font-weight: 400;
            color: #666666;
            text-align: left;
          }
          &:last-child {
            width: 80px;
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            text-align: right;
          }
        }
        .club {
          flex: 1;
          display: flex;
          align-items: center;
          p {
            color: #333333;
          }
          .left {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            p {
              &:first-child {
                flex: 1;
                text-align: right;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              &:last-child {
                width: 18px;
                height: 20px;
                // background: #169AFF;
                margin-left: 3px;
                color: #333333;
              }
            }
          }
          .mid {
            width: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            p {
              &:first-child {
                width: 15px;
                height: 1px;
                background: #D8D8D8;
              }
              &:last-child {
                width: 0;
                border-width: 5px;
                border-style: solid;
                border-color: transparent transparent transparent #D8D8D8;
              }
            }
          }
          .right {
            flex: 1;
            display: flex;
            p {
              &:first-child {
                width: 18px;
                height: 20px;
                // background: #169AFF;
                margin-right: 3px;
              }
              &:last-child {
                flex: 1;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
  }
  .career {
    margin-top: 15px;
    .title {
      padding: 0 12px;
    }
    .table {
      margin-top: 8px;
      display: flex;
      height: 25px;
      background: #F5F5F5;
      p {
        flex: 1;
        line-height: 25px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        text-align: center;
      }
      .big {
        flex: none;
        width: 75px;
      }
    }
    .score {
      margin-top: 20px;
      display: flex;
      align-items: center;
      p {
        flex: 1;
        font-size: 11px;
        font-weight: 400;
        color: #333333;
        text-align: center;
        &:first-child {
          display: flex;
          padding-left: 7px;
          span {
            &:first-child {
              width: 18px;
              height: 20px;
              // background: green;
              margin-right: 3px;
            }
            &:last-child {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
      .big {
        flex: none;
        width: 75px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .personalHonor {
    margin-top: 15px;
    padding: 0 12px;
    .cup {
      height: 105px;
      background: #FFFFFF;
      box-shadow: 0px 3px 5px 0px rgba(0,0,0,0.15);
      border-radius: 4px;
      border: 1px solid #EEEEEE;
      margin-top: 10px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      p {
        &:first-child {
          width: 50px;
          height: 46px;
          background: #169AFF;
          img {
            width: 100%;
            height: 100%;
          }
        }
        &:last-child {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          span {
            &:first-child {
              font-size: 15px;
              font-weight: 500;
              color: #333333;
            }
            &:last-child {
              font-size: 10px;
              font-weight: 400;
              color: #7D7D7D;
            }
          }
        }
      }
    }
    .honor {
      margin-top: 5px;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      // border: 1px solid;
      div {
        width: 86px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 10px;
        p {
          &:first-child {
            font-size: 15px;
            font-weight: 500;
            color: #333333;
          }
          &:last-child {
            font-size: 10px;
            font-weight: 400;
            color: #7D7D7D;
          }
        }
      }
    }
  }
}
.materialDark{
    min-height: 100vh;
    background-color: #191919;
    .title {
        p{
            &:last-child {
                color: #d3d3d3;
            }
        }
    }
    .information {
        .info{
            background: #191919;
            border-color: #191919;
            box-shadow: 0px 3px 5px 0px rgba(255,255,255,0.15);
            .top, .bottom {
                p{
                    color: #d3d3d3;
                    span{
                        color: #a6a6a6;
                    }
                }
            }
        }
    }
    .transfer {
        .recordBox {
            .record {
                div {
                    &:first-child {
                        color: #a6a6a6;
                    }
                    &:last-child {
                        color: #d3d3d3;
                    }
                }
                .club {
                    p {
                        color: #d3d3d3;
                    }
                    .left {
                        p {
                            &:last-child {
                                color: #d3d3d3;
                            }
                        }
                    }
                    .mid {
                        p{
                            &:first-child {
                                background-color: #a6a6a6;
                            }
                            &:last-child {
                                border-color: transparent transparent transparent #a6a6a6;
                            }
                        }
                    }
                }
            }
        }
    }
    .career {
        .table {
            background: #232323;
            p {
                color: #a6a6a6;
            }
        }
        .score {
            p{
                color: #d3d3d3;
            }
        }
    }
    .personalHonor {
        .cup {
            background: #191919;
            border-color: #2f2f2f;
            p{
                &:last-child {
                    span{
                        &:first-child {
                            color: #d3d3d3;
                        }
                        &:last-child {
                            color: #595959
                        }
                    }
                }
            }
        }
        .honor {
            div {
                p {
                    &:first-child {
                        color: #d3d3d3;
                    }
                    &:last-child {
                        color: #595959;
                    }
                }
            }
        }
    }
}
</style>
